import { gql } from '@apollo/client';

const UPDATE_STUDY_DIAGNOSIS_MUTATION = gql`
  mutation updateStudyDiagnosis($input: UpdateStudyDiagnosisInput!) {
    updateStudyDiagnosis(input: $input) {
      isSuccess
      message
      study {
        info {
          diagnosis {
            second
            primary
            patientMedications
          }
        }
      }
    }
  }
`;

export default UPDATE_STUDY_DIAGNOSIS_MUTATION;
